<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-md-12 text-center">
        <h1 class="display-1">403</h1>
        <p class="lead">Accès interdit</p>
        <p>Vous n'avez pas la permission d'accéder à cette page.</p>
        <router-link to="/" class="btn btn-primary"
          >Retour à l'accueil</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Forbidden',
  }
</script>

<style>
  /* Vous pouvez ajouter des styles supplémentaires ici si nécessaire */
</style>
